// extracted by mini-css-extract-plugin
export var container = "sectionCard-module--container--JFx1z";
export var imageContainer = "sectionCard-module--image-container--3AghM";